export var createCompositeBuilder = function (builders) { return ({
    events: function (eventType) { return ({
        select: function (selector) { return ({
            listen: function (listener, listenerOptions) {
                return builders.map(function (builder) { return builder
                    .events(eventType)
                    .select(selector)
                    .listen(listener, listenerOptions); });
            }
        }); }
    }); }
}); };
